module.exports = __webpack_public_path__ + "static/logo.a8a4e6c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 539
// module chunks = 55213770944713 173894859265406